import { ErrorData } from '../../common/models/error.model';
import { UserDetails } from '../../common/models/user-details.model';

export class MenuResponse {
  results?: MenuResults;
  errorData?: ErrorData;
}

export class MenuResults {
  appLinks?: MenuAppLinks;
  header?: MenuHeader;
}

export class MenuHeader {
  showNotificationIcon?: boolean;
  showSearchIcon?: boolean;
  mobileLogo?: string;
  desktopLogo?: string;
  enableBot? : boolean;
  desktopBlueLogo?: string;
  desktopWhiteLogo?: string;
  labelIcon?: string;
}

export class MenuAppLinks {
  bookmarked?: Bookmarks[];
  parentMenu?: ParentMenuObj[];
}

export class Bookmarks { 
  name?: string;
  label?: string;
  link?: string;
  linkType?: string;
  category?: string;
  isFrequentlyVisited?: boolean;
  linkDescription?: string;
  isBookmarked?: boolean;
  hasChild?: boolean;
  iconClass?: string;
  subCategory?: string;
  parentMenuLabel?: string;
  childMenuLabel?: string;
}

export class ParentMenuObj {
  name?: string;
  label?: string;
  link?: string;
  linkType?: string;
  category?: string;
  isFrequentlyVisited?: boolean;
  linkDescription?: string;
  hasChild?: boolean;
  childMenu?: ChildMenuObj[];
}

export class ChildMenuObj {
  name?: string;
  label?: string;
  link?: string;
  linkType?: string;
  category?: string;
  isFrequentlyVisited?: boolean;
  linkDescription?: string;
  hasChild?: boolean;
  subChildMenu?: SubChildMenuObj[];
  parentMenuLabel?: string;
  childMenuLabel?: string;
}

export class SubChildMenuObj {
  parentMenuLabel?: string;
  childMenuLabel?: string;
  name?: string;
  label?: string;
  link?: string;
  linkType?: string;
  category?: string;
  subCategory?: string;
  isFrequentlyVisited?: boolean;
  linkDescription?: string;
  isBookmarked?: boolean;
  hasChild?: boolean;
  iconClass?: string;
}

export class UpdateBookmarkRequest {
  parentMenuName?: string;
  name?: string;
  label?: string;
  link?: string;
  linkType?: string;
  category?: string;
  subCategory?: string;
  linkDescription?: string;
  bookmarkOperation?: string;
  userDetails?: UserDetails;
}
